<template>
  <div class="d-flex" style="overflow-x: auto;">
    <div v-for="value, key in data" :key="key" class="box padded me-3 d-flex" style="min-width: 300px;">
      <div style="flex: 1;">
        <div class="bold d-flex vertically-centered" style="font-size: 1.1rem;">
          <span class="white me-2">
          {{ value }}
          </span>
          <span v-if="key == 'vpn'" style="color: rgb(248, 206, 105); font-size: .8rem;">
            ~{{ Math.floor( (value / total) * 100)  }}%
          </span>
          <span v-if="key == 'proxy'" style="color: rgb(105, 241, 248); font-size: .8rem;">
            ~{{ Math.floor( (value / total) * 100)  }}%
          </span>
        </div>
        <div>
          {{ key }}
        </div>
      </div>
      <div>
        <div style="text-align: right;">
          <font-awesome-icon v-if="key == 'vpn'"  class="icon" :icon="['fas', 'shield-halved']" style="font-size: 1.3rem;"/>
          <font-awesome-icon v-if="key == 'proxy'"  class="icon" :icon="['fas', 'layer-group']" style="font-size: 1.3rem;"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"
import Provider from '@/api/Provider.js'

const data = ref({})
const total = ref(0)

onMounted(async () => {
  data.value = (await Provider.typeStats())
  
  for (const [key, value] of Object.entries(data.value)) {
    total.value += value
  }
})
</script>

<style scoped>

</style>
